import Index from './index.vue'

var plugin = {}
var instances = []
plugin.install = function (Vue, options = {}) {

    const PhoneController = Vue.extend(Index)

    Vue.prototype.$showTelList = (option = []) => {

        return new Promise((resolve, reject) => {

            var instance = new PhoneController().$mount(document.createElement('div'))
            instances.push(instance)
            instance.resolve = resolve
            instance.reject = reject
            instance.phoneList = option
            instance.$nextTick(() => {
                document.body.appendChild(instance.$el)  
            })
        })

    }
}

export default plugin


// WEBPACK FOOTER //
// ./src/plugins/phone/index.js